module.exports = function() {
  return new Worker(__webpack_public_path__ + "d11bd5b96d88beb21ac6.worker.js");
};